/**
 * Bootstrap do app Vue 3.
 *
 * - Registra plugins de UI (Bootstrap-Vue-Next, ApexCharts, Toast, etc.)
 * - Configura axios global (baseURL + cookies)
 * - Conecta o store, router e i18n
 */

import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './state/store';
import axios from 'axios';

// UI e Animacoes
import AOS from 'aos';
import 'aos/dist/aos.css';
import Toast from 'vue-toastification';
import 'vue-toastification/dist/index.css';
import BootstrapVueNext from 'bootstrap-vue-next';
import vClickOutside from 'click-outside-vue3';
import VueApexCharts from 'vue3-apexcharts';
import VueTheMask from 'vue-the-mask';
import VueFeather from 'vue-feather';
import 'bootstrap/dist/js/bootstrap.bundle';

// Estilos
import '@/assets/scss/config/saas/app.scss';
import '@/assets/scss/mermaid.min.css';

// I18n
import i18n from './i18n';

import Multiselect from '@vueform/multiselect';
import AppDatepicker from '@/components/common/AppDatepicker.vue';
import 'flatpickr/dist/flatpickr.css';
import './registerServiceWorker';
import { carregarMarca } from '@/services/marca';

AOS.init({ easing: 'ease-out-back', duration: 1000 });

axios.defaults.baseURL = process.env.VUE_APP_APIURL;
axios.defaults.withCredentials = true;

// Whitelabel: aplica a marca (cores/logo/nome/favicon/manifest) o quanto antes.
// Aplica cache local sincronicamente (sem flash) e atualiza do backend em seguida.
carregarMarca();

const toastOptions = {
  position: 'top-left',
  timeout: 10000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: true,
  hideProgressBar: true,
  closeButton: 'button',
  icon: true,
  rtl: false,
};

const app = createApp(App);

app.use(store)
  .use(router)
  .use(VueApexCharts)
  .use(BootstrapVueNext)
  .use(VueTheMask)
  .use(i18n)
  .use(Toast, toastOptions)
  .use(vClickOutside);

app.component(VueFeather.type, VueFeather);
app.component('Multiselect', Multiselect);
app.component('AppDatepicker', AppDatepicker);

app.config.warnHandler = () => {};
app.config.productionTip = false;

app.mount('#app');

// Service Worker (opcional)
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((registration) => {
        // eslint-disable-next-line no-console
        console.debug('Service Worker registrado:', registration);
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.error('Falha no Service Worker:', error);
      });
  });
}
